@if (isOpen()) {
  <kendo-dialog
    #iqBoostDialog
    [title]="'iqboost.title' | translate"
    (close)="close()"
    width="90%"
    maxWidth="90%"
    height="90%"
    [style.z-index]="'.k-window, .ui-dialog' | maxZIndex: 99990"
  >
    <div class="mx-4 mt-4 flex flex-col min-h-0 overflow-y-auto"
      [ngClass]="{
        'h-[calc(100%-3rem)]': store.accuracyBannerVisible(),
        'h-[calc(100%-2rem)]': !store.accuracyBannerVisible(),
      }"
    >
      <!-- Dialog Header -->
      <div class="flex-none h-[38px]">
        <div class="flex">
          <div class="w-full flex">
            <h6 class="text-black mb-2">
              {{ 'iqboost.title' | translate }} 
            </h6>
            <span class="text-neutral-70 text-base font-normal ml-1 mt-1">
              {{ entryAndOpportunityDisplay() }}
            </span>
            
            <span 
              id="help-iqboost-{{ ViewType[store.viewType()] }}" 
              class="fa-icons icon-solid icon-12 icon-circle-question pl-1 mt-2.5 cursor-pointer text-neutral-90"
              (click)="startUserGuide()"
            ></span>
          </div>

          <div class="flex justify-end w-auto">
            <span 
              class="fa-icons icon-solid icon-xmark icon-16 pt-2 mr-4 cursor-pointer"
              (click)="close()"
            ></span>
          </div>
        </div>
      </div>

      <div class="flex-none w-full mb-2 flex items-center justify-between">
        <div class="flex items-center flex-1 min-w-0 space-x-2">
          <!-- Anonymizer -->
          <div
            class="h-[36px] border rounded px-3 py-2 flex items-center"
            [ngClass]="anonymized() ? 'border-bush-green-80 bg-mint-10' : 'border-warning-100 bg-authorized-5'"
          >
            <span class="relative inline-flex items-center justify-center mr-2">
              <span
                class="maximizer-icons icon-anonymizer icon-24"
                [ngClass]="anonymized() ? 'text-finserv-100' : 'text-warning-100'"
              ></span>
              @if (!anonymized()) {
                <span
                  class="absolute block h-[2px] w-[32px] rounded bg-warning-100"
                  style="transform: translateX(-2px) translateY(-1px) rotate(45deg); box-shadow: 0 1px 0 0 white;"
                ></span>
              }
            </span>
            <span
              class="text-body-2"
              [ngClass]="anonymized() ? 'text-finserv-100' : 'text-warning-100'"
              [innerHTML]="(anonymized() ? 'iqboost.summary.status.anonymizerActive' : 'iqboost.summary.status.anonymizerOff') | translate">
            </span>
          </div>

          <!-- Canadian Servers -->
          <div
            class="h-[36px] border rounded px-3 py-2 flex items-center"
            [ngClass]="!useGlobalServers() ? 'border-bush-green-80 bg-mint-10' : 'border-neutral-30 bg-neutral-5'"
          >
            <span
              class="pr-2"
              [ngClass]="!useGlobalServers() 
                ? 'text-finserv-100 icon-24 maximizer-icons icon-canada-server' 
                : 'text-neutral-90 icon-20 fa-icons icon-earth-americas'"
            ></span>
            <span
              class="text-body-2"
              [ngClass]="!useGlobalServers() ? 'text-finserv-100' : 'text-neutral-90'"
              [innerHTML]="(!useGlobalServers() ? 'iqboost.summary.status.serversCanada' : 'iqboost.summary.status.serversGlobal') | translate">
            </span>
          </div>

          <!-- Data Source -->
          <div
            class="h-[36px] border rounded px-3 py-2 flex items-center"
            [ngClass]="!useWebData() ? 'border-bush-green-80 bg-mint-10' : 'border-neutral-30 bg-neutral-5'"
          >
            <span
              class="pr-2"
              [ngClass]="!useWebData() 
                ? 'text-finserv-100 icon-24 maximizer-icons icon-maximizer-data-server' 
                : 'text-neutral-90 icon-20 fa-icons icon-globe-pointer'"
            ></span>
            <span
              class="text-body-2"
              [ngClass]="!useWebData() ? 'text-finserv-100' : 'text-neutral-90'"
              [innerHTML]="(!useWebData() ? 'iqboost.summary.status.dataSourceMaximizer' : 'iqboost.summary.status.dataSourceOnline') | translate">
            </span>
          </div>
        </div>

        @if (store.viewType() !== ViewType.PrivacySecurityCenter) {
          <ng-container *ngTemplateOutlet="privacySecurityButton"></ng-container>
        }
      </div>
        
      <div class="flex-1 min-h-0 overflow-y-auto w-full">
        <div class="flex flex-1 h-full min-h-0">
          @if (!firstLoad()) {
            @switch (store.viewType()) {
              @case (ViewType.Report) {
                <ai-iqboost-summary class="flex w-full h-full min-h-0"></ai-iqboost-summary>
              }
              @case (ViewType.DetailedReport) {
                <div class="w-full h-full">
                  <ai-iqboost-report class="block h-full">
                  </ai-iqboost-report>
                </div>
              }
              @case (ViewType.Chat) {
                <div class="w-full h-full">
                  <ai-iqboost-chat class="block h-full">
                  </ai-iqboost-chat>
                </div>
              }
              @case (ViewType.PrivacySecurityCenter) {
                <ai-iqboost-privacy-security-center class="flex w-full h-full">
                </ai-iqboost-privacy-security-center>
              }
            }
          } 
        </div>
        
        <!-- Regular loading gif: suppressed while a streaming request shows its
             Cursor-like phase status indicator inside the active view. -->
        @if (store.loading() && !store.streamingStatusKey()) {
          <div class="absolute w-full h-[calc(100%-3rem)] top-12 flex items-center justify-center left-0 z-50">
            <img
              [src]="loadingGifUrl()"
              alt="Loading…"
              loading="lazy"
            />
            <div class="z-10 absolute w-full h-full left-0 bg-white opacity-30">
            </div>
          </div>
        }
      </div>
    </div>   

    <div>
      @if (store.accuracyBannerVisible()) {
        <div class="w-full px-3 flex items-center justify-center">
          <span class="text-xs text-neutral-80 text-center mt-2" 
            [innerHTML]="'iqboost.summary.accuracyDisclaimer' | translate">
          </span>
        </div>
      }
    </div>
  </kendo-dialog>

  <maximizer-notification
    #baseNotifications
    [hideAfter]="3000"
  >
    <p class="text-body-2">
      {{ notificationMessage() | translate }}
    </p>
  </maximizer-notification>

  <ng-template #thinkingTemplate>
    <div class="flex flex-col items-center justify-center w-full h-full space-y-2">
      <img
        class="w-[108px]"
        [src]="cdn + '/assets/images/empty-container.svg'"
        alt="Loading…"
      />
    </div>
  </ng-template>

  <ng-template #privacySecurityButton>
    <div
      class="flex items-center whitespace-nowrap"
      [ngClass]="store.isBusy() ? 'opacity-50 pointer-events-none' : 'cursor-pointer'"
      (click)="openPrivacySecurityCenter()"
    >
      <span class="fa-icons icon-light icon-gear icon-16 text-bush-green-140"></span>
      <span class="text-body-2 font-medium text-bush-green-140 ml-2 pt-0.5">
        {{ 'iqboost.summary.privacySecurityCenter' | translate }}
      </span>
    </div>
  </ng-template>
}

@if (isConfirmationDialogOpen()) {
  <kendo-dialog
    [width]="480"
    [height]="120"
    [style.z-index]="'.k-window, .ui-dialog' | maxZIndex: 99990"
  >
    <div class="p-4 flex">
      <span class="text-body-2">
        {{ confirmationDialogMessage() }}
      </span>
    </div>

    <kendo-dialog-actions layout="end" class="flex justify-end p-4">
      <button
        kendoButton
        class="uppercase"
        themeColor="primary"
        (click)="closeConfirmation(true)"
      >
        {{ 'iqboost.buttons.ok' | translate }}
      </button>

      <button
        kendoButton
        class="uppercase"
        themeColor="secondary"
        (click)="closeConfirmation(false)"
      >
        {{ 'iqboost.buttons.cancel' | translate }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}

@if (store.confirmCreateCRMAction().openDialog) {
  <kendo-dialog
    [width]="580"
    [height]="360"
    [style.z-index]="'.k-window, .ui-dialog' | maxZIndex: 99990"
  >
    <div class="flex flex-col h-full">
      <div class="flex-none p-4 text-center">
        <h6 class="text-lg font-semibold text-black">
          {{ store.confirmCreateCRMAction().displayText }} {{ 'iqboost.labels.for' | translate }} {{ store.confirmCreateCRMAction().for }}
        </h6>
      </div>

      <div class="flex-1 overflow-y-auto px-4 space-y-4">
        <!-- Title -->
        <div class="space-y-1">
          <span class="block text-sm font-medium text-neutral-70">
            {{ 'iqboost.labels.title' | translate }}
          </span>
          <span class="block text-body-2 text-black">
            <span
              [innerHTML]="store.confirmCreateCRMAction().title | deAnonymizer | safeHtml"
            >
            </span>
          </span>
        </div>

        <!-- Description -->
        <div class="space-y-1">
          <span class="block text-sm font-medium text-neutral-70">
            {{ 'iqboost.labels.description' | translate }}
          </span>
          <span class="block text-body-2 text-black"
            [innerHTML]="store.confirmCreateCRMAction().description | deAnonymizer | safeHtml"
          >
          </span>
        </div>

        <!-- Date -->
        <div class="space-y-1">
          <span class="block text-sm font-medium text-neutral-70">
            {{ 'iqboost.labels.date' | translate }}
          </span>
          <span class="block text-body-2 text-black">
            {{ store.confirmCreateCRMAction().date }}
          </span>
        </div>
      </div>

      <div class="flex-none border-t border-neutral-20 p-4">
        <div class="flex justify-end space-x-2">
          <button
            kendoButton
            class="uppercase"
            themeColor="primary"
            (click)="createCRMAction(store.confirmCreateCRMAction())"
          >
            {{ 'iqboost.buttons.create' | translate }}
          </button>
    
          <button
            kendoButton
            class="uppercase"
            themeColor="secondary"
            (click)="store.setIsOpenConfirmCreateCRMAction(false)"
          >
            {{ 'iqboost.buttons.cancel' | translate }}
          </button>
        </div>
      </div>
    </div>
  </kendo-dialog>
}

@if (store.anonymizedInAnimation().animate) {
  <kendo-dialog
    [width]="500"
    [height]="40"
    [style.z-index]="'.k-window, .ui-dialog' | maxZIndex: 99990"
    [animation]="{ type: 'fade', duration: 500 }"
    class="anonymizer-dialog"
  >
    <div class="p-4 flex items-center justify-center h-full"
         [ngClass]="{
           'bg-warning-100': !store.anonymizedInAnimation().anonymized,
           'bg-finserv-100': store.anonymizedInAnimation().anonymized
         }">
      <div class="flex items-center space-x-3">
        <i 
          class="fa-icons icon-16 text-white"
          [ngClass]="{
            'icon-lock-keyhole': store.anonymizedInAnimation().anonymized,
            'icon-lock-keyhole-open': !store.anonymizedInAnimation().anonymized,
          }"
        ></i>
        <span class="text-body-2 text-white">
          {{ 
            store.anonymizedInAnimation().anonymized
              ? ('iqboost.anonymization.anonymized' | translate) 
              : ('iqboost.anonymization.deAnonymized' | translate) 
          }}
        </span>
      </div>
    </div>
  </kendo-dialog>
}

@if (store.showErrorMessageDialog()) {
  <kendo-dialog
    [width]="460"
    [minHeight]="175"
    [maxHeight]="220"
    [style.z-index]="'.k-window, .ui-dialog' | maxZIndex: 99990"
  >
    <div class="px-5" >
      <h6 class="py-4 flex text-black">
        {{ 'iqboost.error.title' | translate }}
      </h6>

      <div class="flex">
        <img
          class="w-[62px] mr-4"
          [src]="cdn + '/assets/images/ai-error-message.svg'"
          alt="Loading…"
        />

        <span class="text-body-2 text-black whitespace-pre-line">
          {{ 'iqboost.error.message' | translate }}
        </span>
      </div>

      <div class="flex justify-end my-5">
        <button
          kendoButton
          class="uppercase"
          themeColor="primary"
          (click)="store.setShowErrorMessageDialog(false)"
        >
          {{ 'iqboost.buttons.ok' | translate }}
        </button>
      </div>
    </div>
  </kendo-dialog>
}

@if (isSuggestPromptDialogOpen()) {
  <kendo-dialog
    [width]="480"
    [height]="460"
    [style.z-index]="'.k-window, .ui-dialog' | maxZIndex: 99990"
  >
    <div class="flex flex-col h-full">
      <!-- Dialog Header -->
      <div class="flex-none p-4">
        <div class="flex items-center justify-between">
          <h6 class="text-neutral-90">
            {{ 'iqboost.suggestPrompt.title' | translate }}
          </h6>
          <span 
            class="fa-icons icon-solid icon-xmark icon-16 cursor-pointer"
            (click)="isSuggestPromptDialogOpen.set(false)"
          ></span>
        </div>
      </div>

      <!-- Dialog Body -->
      <div class="flex-1 px-4 space-y-4">
        <p class="text-body-2 text-neutral-90">
          {{ 'iqboost.suggestPrompt.body' | translate }}
        </p>

        <div class="space-y-2">
          <span class="block text-body-2 text-black">
            {{ 'iqboost.suggestPrompt.subtitle' | translate }}
          </span>
          <kendo-textarea
            [placeholder]="'iqboost.suggestPrompt.placeholder' | translate"
            (valueChange)="suggestPromptBody.set($event)"
            class="w-full text-body-2"
            [rows]="8"
            [ngClass]="{
              'k-invalid': isNullOrEmpty(suggestPromptBody().trim())
            }"
          ></kendo-textarea>
          @if (isNullOrEmpty(suggestPromptBody().trim())) {
            <span class="block text-error text-xs">
              {{ 'iqboost.suggestPrompt.error' | translate }}
            </span>
          }
        </div>
      </div>

      <!-- Dialog Actions -->
      <div class="flex-none p-4">
        <div class="flex justify-end space-x-2">
          <button
            kendoButton
            class="uppercase"
            themeColor="secondary"
            (click)="isSuggestPromptDialogOpen.set(false)"
          >
            {{ 'iqboost.suggestPrompt.buttons.cancel' | translate }}
          </button>
          <button
            kendoButton
            class="uppercase"
            themeColor="primary"
            [disabled]="isNullOrEmpty(suggestPromptBody().trim())"
            (click)="sendSuggestion()"
          >
            {{ 'iqboost.suggestPrompt.buttons.sendSuggestion' | translate }}
          </button>
        </div>
      </div>
    </div>
  </kendo-dialog>
}

